module.exports = __webpack_public_path__ + "img/Group20@2x.df50e33a.png";